import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import * as api from '../../../../services/api';
import { IMAGE_PREFIX } from '../../../../constants/constants';


class RenewalNotAvailable extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            logo: null, 
            isError: this.props.location.state.isError
        };
    }

    componentDidMount(){
        const customerPromise = api.customers.getBySecret(this.props.location.state.queryParams);
        customerPromise
        .then((customerResponse) => {
          return api.images.getLogo(customerResponse.data.languageCode);
        })
        .then((logoResponse) => {
            this.setState({
                logo: IMAGE_PREFIX + logoResponse.data.value
            })
        })
    }

    render() {
        return (
        <div>
            <div>
            <h1 className="customer-renewal-view-logo">
                <img src={this.state.logo} alt="C3 Link" />
            </h1>
            </div>
            <div className="main-container">
                {!this.state.isError ? 
                (<h3 style={{ width: '100%', lineHeight: '50px', margin: '10px' }}>
                    {this.props.intl.formatMessage({ id: 'renewal_not_available' })}
                </h3>) : 
                (<h3 style={{ width: '100%', lineHeight: '50px', margin: '10px' }}>
                    {this.props.intl.formatMessage({ id: 'error_getting_renewal' })}
                </h3>)}
            </div>
        </div>
        );
    }
}

export default injectIntl(withRouter(RenewalNotAvailable));
